import { FC } from 'react';
import { ThemeProvider } from 'styled-components';
import { getTheme } from '@belong/themes';
import { ITheme } from '@belong/types';
import { IntroductionText as UI } from '@belong/ui-components';
import Section from '@belong/ui-components/components/styles/Section';
import { ISectionIntroductionText } from './model';

const IntroductionText: FC<ISectionIntroductionText> = ({ id, identifier, sectionStyles, ...props }) => {
  let currentTheme: ITheme | undefined;
  if (sectionStyles?.themeVariation) {
    const isDarkTheme = sectionStyles.themeVariation === 'Dark';
    currentTheme = getTheme({ isDark: isDarkTheme });
  }

  return (
    <ThemeProvider
      theme={(theme = getTheme()) => ({
        ...theme,
        ...currentTheme
      })}
    >
      <Section
        data-identifier={identifier}
        data-contentid={id}
        data-testid={props['data-testid'] || 'section-introduction-text'}
        {...sectionStyles}
      >
        <UI {...props} />
      </Section>
    </ThemeProvider>
  );
};

export default IntroductionText;
